import { createSelector } from "reselect";

export const selectTrafficDashboard = state => state.trafficDashboard;

export const selectOpenAdmanagementDialog = createSelector(
  [selectTrafficDashboard],
  trafficDashboard => trafficDashboard.openAdmanagementDialog
);
